import { format, parseISO } from "date-fns";
import { utcToZonedTime } from "date-fns-tz";
export const formatDateToEST = ({ date, dateFormat }) => {
    const dateParsed = parseISO(date.toString());
    const timeZone = "America/New_York";
    const zonedDate = utcToZonedTime(dateParsed, timeZone);
    return dateFormat ? format(zonedDate, dateFormat) : zonedDate;
};
export const getDiffInHoursEST = (date) => {
    const currentDate = formatDateToEST({ date: new Date() });
    const eventDate = formatDateToEST({ date: date });
    const diffInMilliseconds = Math.abs(currentDate.getTime() - eventDate.getTime());
    const diffInHours = Math.floor(diffInMilliseconds / (1000 * 3600));
    return diffInHours;
};
